import {
	createSelector,
} from '@reduxjs/toolkit';
import {
	ReducerInstance,
} from '@stores/lpdipro/reducers';

export const selectAppState = (state: ReducerInstance) => state.app;

export const selectCurrentLanguage = createSelector(
	selectAppState,
	(state) => state?.localization?.actualLanguage,
);

export const selectIsNavOpen = (state: ReducerInstance) => {
	const display = state.device?.instance?.display;
	if (!display) return false;
	const app = selectAppState(state);
	return Boolean(app?.[display]?.navIsOpen);
};
